import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { calculateOverdueColorByDays, getSeverityColor } from "../../../../services/helpers";

type Props = {
  paidOnTimePercent?: number;
  averageOverdueDays?: number;
};

export function AveragePaymentTime({ paidOnTimePercent, averageOverdueDays }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  if (typeof paidOnTimePercent !== "number") {
    return <Typography>Insufficient Data</Typography>;
  }

  const getThemeColor = (severity: "error" | "warning" | "success") => {
    if (isDarkMode) {
      if (severity === "error") return theme.palette.error.main;
      if (severity === "warning") return theme.palette.warning.main;
      if (severity === "success") return theme.palette.success.main;
    }
    return getSeverityColor(severity);
  };

  const overdueText = getOverdueText(averageOverdueDays);
  const historicPaymentSeverity = paidOnTimePercent >= 75 ? "success" : paidOnTimePercent > 50 ? "warning" : "error";
  const historicPaymentColor = getThemeColor(historicPaymentSeverity);

  return (
    <Box>
      <Typography>
        Pays on time in{" "}
        <strong style={{ color: historicPaymentColor }}>
          {new Intl.NumberFormat(Office.context.displayLanguage, { style: "percent", maximumFractionDigits: 2 }).format(
            paidOnTimePercent / 100
          )}
        </strong>{" "}
        of cases
      </Typography>
      {overdueText && (
        <Typography color={getThemeColor(calculateOverdueColorByDays(averageOverdueDays!))}>{overdueText}</Typography>
      )}
    </Box>
  );
}

function getOverdueText(averageOverdueDays?: number) {
  if (typeof averageOverdueDays !== "number") return null;

  if (averageOverdueDays === 0) return "(on time)";

  return `(${averageOverdueDays} days overdue on average)`;
}
